import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice/authSlice";
import companyReducer from "./companySlice/companySlice";
import contractReducer from "./contractSlice/contractSlice";
import branchReducer from "./branchSlice/branchSlice";
import maintenanceScheduleReducer from "./MaintenanceScheduleSlice/MaintenanceScheduleSlice";
import maintenanceItemSReducer from "./MaintenanceItemSlice/MaintenanceItemSlice";
import standardMaintenanceItemReducer from "./StandardMaintenanceItemSlice/StandardMaintenanceItemSlice";
import userReducer from "./userSlice/userSlice";
import notificationReducer from "./notificationSlice/notificationSlice";
import maintenanceTypeReducer from "./MaintenanceTypeSlice/MaintenanceTypeSlice";
export const store = configureStore({
  reducer: {
    auth: authReducer,
    company: companyReducer,
    branch: branchReducer,
    contract: contractReducer,
    maintenanceSchedule: maintenanceScheduleReducer,
    maintenanceItems: maintenanceItemSReducer,
    standardMaintenanceItems: standardMaintenanceItemReducer,
    maintenanceType: maintenanceTypeReducer,
    user: userReducer,
    notification: notificationReducer,
  },
  devTools: true,
});
